export const SCALE_COLOR_MAP: Record<number, string[]> = {
  2: ["var(--values-scale-color-success)", "var(--values-scale-color-danger)"],
  3: [
    "var(--values-scale-color-success)",
    "var(--values-scale-color-caution)",
    "var(--values-scale-color-danger)",
  ],
  4: [
    "var(--values-scale-color-success)",
    "var(--values-scale-color-warning)",
    "var(--values-scale-color-caution)",
    "var(--values-scale-color-danger)",
  ],
  5: [
    "var(--values-scale-color-success)",
    "var(--values-scale-color-success-soft)",
    "var(--values-scale-color-warning)",
    "var(--values-scale-color-caution)",
    "var(--values-scale-color-danger)",
  ],
};
